<div class="d-flex w-100 justify-content-between">
    <h2 mat-dialog-title>
        Maatregelen samenvoegen
    </h2>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="search-list">
        <div class="search-item">
            <div class="check">

            </div>
            <div class="image" app-svg-as-img [ttm]="ttm"></div>
            <div class="info justify-content-between">
                <div class="ps-0 ps-sm-4">
                    <div class="d-flex justify-content-between">
                        <div>
                            #{{ttm.id}}
                        </div>
                        <small *ngIf="ttm.type?.count"><i class="fa fa-calculator "></i> {{ttm.amount ?? 1}}</small>
                    </div>
                    <small>{{(ttmTypes | byKey : ttm.type_key)?.name}}</small>
                </div>
                <div>
                    <app-status-chip class="mt-1 me-3" [statusKey]="ttm?.status_key" [ttmStatuses]="ttmStatuses"></app-status-chip>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>
        <h2 mat-dialog-title>Samenvoegen met: </h2>
        <mat-divider class="mt-1"></mat-divider>
        <div class="items">
            @for (ttm of nearbyTtms; track ttm.id) {
                <div matRipple class="search-item" (click)="$event.stopPropagation(); checked.controls[ttm.id].setValue(!checked.value[ttm.id]);">
                    <div class="check">
                        <mat-checkbox [checked]="checked.value[ttm.id]"></mat-checkbox>
                    </div>
                    <div class="image" app-svg-as-img [ttm]="ttm">
                        <small *ngIf="ttm.type?.count"><i class="fa fa-calculator"></i> {{ttm.amount ?? 1}}</small>
                    </div>
                    <div class="info justify-content-between">
                        <div class="ps-0 ps-sm-4">
                            <div class="d-flex justify-content-between">
                                <div>
                                    #{{ttm.id}}
                                </div>
                                <small *ngIf="ttm.type?.count"><i class="fa fa-calculator "></i> {{ttm.amount ?? 1}}</small>
                            </div>
                            <small>{{(ttmTypes | byKey : ttm.type_key)?.name}}</small>

                        </div>
                        <div>
                            <app-status-chip class="mt-1 me-3" [statusKey]="ttm?.status_key" [ttmStatuses]="ttmStatuses"></app-status-chip>
                        </div>
                    </div>
                </div>
                <mat-divider></mat-divider>
            }
        </div>
    </div>

</mat-dialog-content>
<mat-dialog-actions class="justify-content-between">
    <button mat-button type="button" mat-dialog-close>Sluiten</button>
    <button mat-raised-button color="primary" type="button" (click)="merge()">Samenvoegen</button>
</mat-dialog-actions>
